import React from 'react';
import { Helmet } from 'react-helmet';

const Terminos: React.FC = () => {
  return (
    <div className="px-5 py-8 font-[Arial,sans-serif] max-w-[800px] mx-auto leading-relaxed bg-[#05603c] text-gray-200">
      <Helmet>
        <title>Términos y Condiciones | El Chel</title>
        <meta name="description" content="Términos y condiciones de uso del sitio web oficial de El Chel, restaurante de cochinita pibil en CDMX." />
      </Helmet>

      <h1 className="text-2xl font-bold mb-2.5 text-center text-brand-deep">Términos y Condiciones</h1>
      <p className="text-base mb-4 text-gray-200 text-justify">
        Bienvenido a El Chel, el sitio web oficial de nuestro restaurante. Al acceder y usar este sitio web, aceptas los
        términos y condiciones descritos a continuación. Por favor, léelos detenidamente.
      </p>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">1. Uso del Sitio Web</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        Este sitio está destinado únicamente para proporcionar información sobre nuestro restaurante, incluyendo
        sucursales, menú, redes sociales oficiales y medios de contacto. No se permite el uso indebido del sitio web,
        como la reproducción no autorizada de contenido o la distribución sin permiso.
      </p>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">2. Propiedad Intelectual</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        Todos los derechos sobre el contenido del sitio web, incluyendo imágenes, logotipos, textos y diseños,
        pertenecen a El Chel. No está permitido copiar, reproducir, distribuir o usar el contenido sin autorización
        previa y por escrito.
      </p>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">3. Cuentas Oficiales</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        Las únicas cuentas oficiales del restaurante El Chel son las siguientes:
      </p>
      <ul className="list-none p-0 m-0 mb-4 space-y-1">
        <li>
          <a href="https://www.instagram.com/elchel_oficial/" className="text-brand-deep no-underline font-bold hover:underline" target="_blank" rel="noopener noreferrer">
            Instagram: @elchel_oficial
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/profile.php?id=61572273834288" className="text-brand-deep no-underline font-bold hover:underline" target="_blank" rel="noopener noreferrer">
            Facebook: EL Chel
          </a>
        </li>
        <li>WhatsApp: Disponible en las sucursales a través de los números indicados.</li>
      </ul>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">4. Enlaces Externos</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        Este sitio puede contener enlaces a redes sociales u otras plataformas externas. No somos responsables por el
        contenido, políticas o prácticas de sitios web externos.
      </p>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">5. Limitación de Responsabilidad</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        El Chel no será responsable por errores u omisiones en la información presentada en este sitio. Aunque
        intentamos mantener el contenido actualizado y preciso, no garantizamos la disponibilidad o exactitud completa
        de la información.
      </p>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">6. Privacidad</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        No recopilamos ni almacenamos información personal a través de este sitio web. Las interacciones mediante
        enlaces de contacto, como WhatsApp o correo electrónico, se regirán por las políticas de privacidad de esas
        plataformas.
      </p>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">7. Cambios en los Términos</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        El Chel se reserva el derecho de modificar estos términos y condiciones en cualquier momento. Las actualizaciones
        se reflejarán en esta página y te recomendamos revisarlas periódicamente.
      </p>

      <h2 className="text-lg font-bold mt-5 mb-2.5 text-black">8. Contacto</h2>
      <p className="text-base mb-4 text-gray-200 text-justify">
        Si tienes alguna pregunta o comentario sobre estos términos, puedes contactarnos a través del siguiente correo electrónico:
      </p>
      <p className="text-base mb-4 text-gray-200">
        <a href="mailto:elcheloficial@gmail.com" className="text-brand-deep no-underline font-bold hover:underline">
          Correo General: elcheloficial@gmail.com
        </a>
      </p>
    </div>
  );
};

export default Terminos;
